import { createRoute, redirect } from "@tanstack/react-router";

import { root } from "routes";

import Layout from "theme/ui/Layout";
import Home from "areas/home/pages/Home";


const _root = createRoute({
	getParentRoute: () => root,
	id: "home-layout",
	component: () => <Layout.Light />
});

const index = createRoute({
	getParentRoute: () => _root,
	path: "/",
	component: () => <Home />,
	beforeLoad: ({ context }) => {
		if (!context.auth0?.isAuthenticated) throw redirect({ to: "/auth" });
	},
	staticData: {
		footer: true
	}
});


const home = _root.addChildren([index]);
export default home;